import React, { useEffect } from 'react';
/* import { useLanguage } from '../../../../../store/languageContext';
import { LanguageFactory } from '../../../../../factories'; */
import { Tabs, Card, Row, Col, Button } from 'antd';
import PageContainer from '../../../../CSIComponents/PageContainer';
import ReadOnlyTextarea from '../../../../CSIComponents/ReadOnlyTextarea';
import DetailItem from '../../../../CSIComponents/DetailItem';

const { TabPane } = Tabs;
interface propsTypes {

    otherPoliciesDetails:any,
    isEditable: void | any
    changeTab: void | any
}

const OtherPoliciesDetail = (props:propsTypes) => {
/*     const { language } = useLanguage()
    const lang = new LanguageFactory(language) */
    const toggleToEdit = ()=>{
        props.isEditable();
        props.changeTab('OtherPoliciesEdit')
    }
    
    useEffect(() => {
        
    }, [])
    
    const edit = () => {
        return <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div style={{margin: '0 10px 0 0'}}>
                        <Button className="db-edit-btn" onClick={() => { props.changeTab('OtherPolicies') }}>Back</Button>
                    </div>
                    <div>
                        <Button type="primary" className="db-edit-btn" onClick={toggleToEdit}>Edit</Button>
                    </div>
                </div>
    } 

    return (
        <Tabs defaultActiveKey="detail">
            <TabPane tab="Detail" key="detail">
                <PageContainer>
                    <Card style={{marginTop:-15}} title={props?.otherPoliciesDetails?.name} extra={edit()}>
                        <div style={{padding:"0 20px"}}>
                            <Row gutter={24}>
                                <Col span={8} className="col-margin">
                                    <DetailItem value={props?.otherPoliciesDetails?.name} label="Policy Name" />
                                </Col>
                                <Col span={15} className="col-margin"></Col>
                                <Col span={16}>
                                    <ReadOnlyTextarea value={props?.otherPoliciesDetails?.description} label="Description" />
                                </Col>
                            </Row>
                        </div>
                    </Card>
                </PageContainer>
            </TabPane>
        </Tabs>
    
    )
}

export default OtherPoliciesDetail;

